import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotesAndAttachmentsService {
  constructor(private http: HttpClient) {}

  createNoteAndAttachment(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/fleet/note-attachments/create`,
      payload,
    );
  }

  getNotesAndAttachmentByFleet(id: any): Observable<any> {
    return this.http.get(
      `${SETTINGS.BASE_API}/fleet/note-attachments/get/${id}`,
    );
  }

  updateNoteAndAttachment(payload: any): Observable<any> {
    return this.http.put(
      `${SETTINGS.BASE_API}/fleet/note-attachments/update`,
      payload,
    );
  }
}
